import { Localization, SelectionHighlighted } from 'utils';

export const plotlyControls: Record<string, any> = {
    [Localization.US]: {
        highlighted: {
            [SelectionHighlighted.TOTAL_DEFINED_SEGMENT]:
                SelectionHighlighted.TOTAL_DEFINED_SEGMENT,
            [SelectionHighlighted.SEX]: SelectionHighlighted.SEX,
            [SelectionHighlighted.AGE_GROUP]: SelectionHighlighted.AGE_GROUP,
            [SelectionHighlighted.ETHNIC_GROUP]: SelectionHighlighted.ETHNIC_GROUP,
            [SelectionHighlighted.CATEGORY]: SelectionHighlighted.CATEGORY,
            [SelectionHighlighted.SUBCATEGORY]: SelectionHighlighted.SUBCATEGORY,
            [SelectionHighlighted.NONE]: SelectionHighlighted.CATEGORY,
        },
        per_anum: {
            ['Cumulative']: 'Cumulative',
            ['Per annum']: 'Per annum',
        },
    },
    [Localization.UK]: {
        highlighted: {
            [SelectionHighlighted.TOTAL_DEFINED_SEGMENT]:
                SelectionHighlighted.TOTAL_DEFINED_SEGMENT,
            [SelectionHighlighted.SEX]: SelectionHighlighted.SEX,
            [SelectionHighlighted.AGE_GROUP]: SelectionHighlighted.AGE_GROUP,
            [SelectionHighlighted.ETHNIC_GROUP]: SelectionHighlighted.ETHNIC_GROUP,
            [SelectionHighlighted.CATEGORY]: SelectionHighlighted.CATEGORY,
            [SelectionHighlighted.SUBCATEGORY]: SelectionHighlighted.SUBCATEGORY,
            [SelectionHighlighted.NONE]: SelectionHighlighted.CATEGORY,
        },
        per_anum: {
            ['Cumulative']: 'Cumulative',
            ['Per annum']: 'Per annum',
        },
    },
};
